import main from './main'
import { catchAsyncActionError } from './utils/catchErrors'

catchAsyncActionError(main)()
